import classNames from 'classnames'
import React, { useState } from 'react'
import { IResponse as ISubmitApiResponse } from 'marketing-site/pages/api/forms/submit'
import { IMarketoFormValues, MarketoFormV2 } from '../MarketoFormV2'

import { IProps } from './index'
import { useSessionStorage } from '../../hooks/use-session-storage'

export const MultiStepForm: React.FC<IProps> = ({
  marketoProps,
  formFields,
  submitButtonLabels,
}) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [formLeadId, setFormLeadId] = useState<number | undefined>(0)
  const [partialFormValues, setPartialFormValues] = useSessionStorage<IMarketoFormValues>(
    'partial-view-demos-form',
    {},
  )

  const formFieldsValues = Object.values(formFields)

  return (
    <div className="multi-step-form" data-testid="multi-step-form">
      {formFieldsValues.map((fields, index) => {
        const stepClassNames = classNames('multi-step-form__step', {
          'multi-step-form__step--active': currentStep === index,
          'multi-step-form__step--past': currentStep > index,
        })

        const isLastStep = index + 1 === formFieldsValues.length
        const onSubmit = !isLastStep
          ? (result: ISubmitApiResponse, values?: IMarketoFormValues) => {
              if (result.success) {
                setFormLeadId(result.result?.id)
                values && setPartialFormValues({ ...partialFormValues, ...values })
                setCurrentStep(index + 1)
              }
            }
          : undefined

        return (
          <div key={`${index}${submitButtonLabels[index]}`} className={stepClassNames}>
            <MarketoFormV2
              {...marketoProps}
              submitButtonLabel={submitButtonLabels[index]}
              formFields={fields}
              formLeadId={formLeadId}
              onSubmit={onSubmit}
              theme="rounded"
              hideLabels={true}
              icon={isLastStep ? marketoProps.icon : undefined}
              isMultiStepSubmit={true}
              waitForSubmit={true}
              extraSubmitValues={partialFormValues}
            />
          </div>
        )
      })}
      <style jsx>{`
        .multi-step-form {
          display: grid;
          grid-template-columns: 1fr;
          width: 100%;
          overflow-x: hidden;
          padding-top: 1.25rem;
          padding-bottom: 1.25rem;
          &__step {
            position: relative;
            grid-row-start: 1;
            grid-column-start: 1;
            opacity: 0;
            animation-delay: 0.5s;
            display: none;
            &--active {
              display: block;
              animation: showActive 0.5s ease-in forwards;
              z-index: 1;
            }
            &--past {
              animation: hidePast 0.5s ease-out forwards;
            }
          }
        }

        @keyframes showActive {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes hidePast {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  )
}
